// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__GeJpa","spinner-aib1d7":"Loader_spinner-aib1d7__R7bjj"};